import { useToast } from '@hover/blueprint';
import { useEffect, useState } from 'react';

import { Designer } from 'src/shared/constants/FeatureFlag';
import {
  TranslationNamespace,
  useTranslate,
  useTreatment,
} from 'src/shared/hooks';
import { isEnabled } from 'src/shared/telemetry/featureFlag';

export const useDegradedPerformanceToast = () => {
  const [hasShownToast, setHasShownToast] = useState(false);
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const toast = useToast({
    description: t('degradedPerformanceToast'),
    status: 'error', // MEOW-6742
    duration: null,
  });
  const degradedPerformance = isEnabled(
    useTreatment(Designer.DEGRADED_PERFORMANCE_TOAST),
  );

  useEffect(() => {
    if (degradedPerformance && !hasShownToast) {
      toast();
      setHasShownToast(true);
    }
  }, [toast, degradedPerformance, hasShownToast, setHasShownToast]);
};
